import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import Cw8Edit from "components/cw8/Cw8Edit";

export const AutorSectionPublicationsEdit: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "autorSectionPublication";
    return (
        <Cw8Edit
            resourceName = {resourceName}
        ></Cw8Edit>
    );
};
